import PropTypes from 'prop-types';
import { Stack } from '@mui/material';

import { ColorButton } from 'components/simple';
import { ButtonArrowDownIcon, ButtonArrowUpIcon, DeleteIcon } from 'assets/icons';

export const QuestionItemsButtons = ({ formPrefix, itemType, itemsList, currentItemIndex, onUpdateItemsList }) => {
  if (itemsList.length === 1) {
    return null;
  }

  return (
    <Stack spacing={1.5} direction="row">
      <ColorButton
        icon={ButtonArrowUpIcon}
        color="secondary"
        id={`${formPrefix}-move-up-${itemType}`}
        disabled={currentItemIndex === 0}
        onClick={() => {
          onUpdateItemsList(
            itemsList.toSpliced(
              currentItemIndex - 1,
              2,
              ...itemsList.slice(currentItemIndex - 1, currentItemIndex + 1).toReversed(),
            ),
          );
        }}
      />

      <ColorButton
        icon={ButtonArrowDownIcon}
        color="secondary"
        id={`${formPrefix}-move-down-${itemType}`}
        disabled={currentItemIndex === itemsList.length - 1}
        onClick={() => {
          onUpdateItemsList(
            itemsList.toSpliced(
              currentItemIndex,
              2,
              ...itemsList.slice(currentItemIndex, currentItemIndex + 2).toReversed(),
            ),
          );
        }}
      />

      <ColorButton
        icon={DeleteIcon}
        color="error"
        id={`${formPrefix}-remove-${itemType}`}
        onClick={() => {
          onUpdateItemsList(itemsList.toSpliced(currentItemIndex, 1));
        }}
      />
    </Stack>
  );
};

QuestionItemsButtons.propTypes = {
  formPrefix: PropTypes.string.isRequired,
  itemType: PropTypes.string.isRequired,
  itemsList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currentItemIndex: PropTypes.number.isRequired,
  onUpdateItemsList: PropTypes.func.isRequired,
};
